import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "qi-311"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M12.254 2.086a3.147 3.147 0 0 0-.397.04 4.675 4.675 0 0 0-7.838 0 3.147 3.147 0 0 0-.396-.04 3.184 3.184 0 1 0 1.243 6.116 4.61 4.61 0 0 0 6.144 0 3.185 3.185 0 1 0 1.244-6.116zm0 5.369a2.17 2.17 0 0 1-.853-.173 1 1 0 0 0-1.05.167 3.61 3.61 0 0 1-4.826 0 1 1 0 0 0-1.05-.167 2.185 2.185 0 1 1-.852-4.196 1.236 1.236 0 0 1 .17.018l.101.014a1 1 0 0 0 .962-.444 3.675 3.675 0 0 1 6.165 0 1 1 0 0 0 .961.444l.102-.014a1.236 1.236 0 0 1 .17-.018 2.184 2.184 0 1 1 0 4.369zm-5.316 5.907a1 1 0 0 0 2 0 6.604 6.604 0 0 0-1-2 6.604 6.604 0 0 0-1 2zm-5-1.669a1 1 0 0 0 2 0 6.604 6.604 0 0 0-1-2 6.604 6.604 0 0 0-1 2zm10.026 0a1 1 0 0 0 2 0 6.604 6.604 0 0 0-1-2 6.604 6.604 0 0 0-1 2zM.734 8.975a.5.5 0 0 0-.5.5v1.999a.5.5 0 0 0 1 0V9.475a.5.5 0 0 0-.5-.5zm4.72 1.382a.5.5 0 0 0-.5.5v1.999a.5.5 0 0 0 1 0v-2a.5.5 0 0 0-.5-.5zm4.996.006a.5.5 0 0 0-.5.5v1.999a.5.5 0 0 0 1 0v-2a.5.5 0 0 0-.5-.5zm4.816-1.388a.5.5 0 0 0-.5.5v1.999a.5.5 0 0 0 1 0V9.475a.5.5 0 0 0-.5-.5z" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }